import {
  SvgIconProps,
} from '@mui/material/SvgIcon';
import clsx from 'clsx';
import {
  ledgerColors,
  useColorsHashMap,
} from 'pages/Dashboard/pages/Encounters/hooks';
import React, {
  FC,
} from 'react';
import {
  formatMoney,
} from '@populateui/utils';

type AmountItemColor = keyof typeof ledgerColors;

const summaryItemTextSizes = {
  small: 'text-md',
  medium: 'text-lg',
  large: 'text-xl',
};

type TextSize = keyof typeof summaryItemTextSizes;

export type AmountSummaryItem = {
  Icon: FC<SvgIconProps>;
  title: string;
  variant: AmountItemColor;
  textSize?: TextSize;
};

export type AmountSummaryProps = AmountSummaryItem & {
  value?: number;
};

export default function AmountSummary({
  Icon,
  title,
  value,
  variant,
  textSize = 'large',
}: AmountSummaryProps) {
  const colors = useColorsHashMap();
  const color = colors[variant ?? ''];
  const textSizeClass = summaryItemTextSizes[textSize];

  return (
    <div className={clsx(
      'flex relative gap-2 px-2 pt-3 pb-2 items-center !bg-transparent border rounded-md cursor-default w-48',
      color,
    )}
    >
      <div className="font-semibold text-xs absolute left-1 -top-2 bg-white px-2 text-black">{title}</div>
      <div className={clsx('bg-blue-400 h-8 w-8 justify-center items-center flex text-white rounded-md', color)}>
        <Icon className="!text-white" />
      </div>
      <div className="flex flex-col justify-between">
        <div className={clsx('font-semibold !bg-transparent', color, textSizeClass)}>
          {formatMoney(value ?? 0)}
        </div>
      </div>
    </div>
  );
}
